import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, Tooltip, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ReactExport from "react-export-excel";

const useStyles = makeStyles((theme) => ({
    title: {
        marginBottom: theme.spacing(1)
    },
    download: { 
        textDecoration: 'none', color: '#212121'
    }
  }));

const ActionSection = (props) => {
    const classes = useStyles();
    const {t} = useTranslation('secondDelivery');
    const {onCreateBatch, onAutoDelivery, onTransferToDriver, downloadExcel} = props

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    return (
        <div>
            <Typography className={classes.title}>{t('common:actions')}</Typography>
            <Grid container spacing={1}>
                <Grid item xs={2}>
                    <Button 
                        color='primary' 
                        variant='contained'
                        fullWidth
                        onClick={()=>onCreateBatch()}
                    >
                        {t('create_sub_batch')}
                    </Button>
                </Grid>
                <Grid item xs={2}>
                    <Tooltip title={t('update_to_delivered_hint')}>
                        <Button 
                            color='primary' 
                            variant='contained' 
                            fullWidth
                            onClick={onAutoDelivery}
                        >{t('update_to_delivered')}</Button>
                    </Tooltip>
                </Grid>
                <Grid item xs={2}>
                    <Button 
                        color='primary' 
                        variant='contained' 
                        fullWidth
                        onClick={onTransferToDriver}
                    >{t('transfer_to_driver')}</Button>
                </Grid>
                {
                    downloadExcel.length <= 0 &&
                    <Grid item xs={2}>
                        <Button 
                            variant="contained"
                            disabled
                        >
                            {t('download_excel')}
                        </Button>
                    </Grid>
                }
                {
                    downloadExcel.length > 0 &&
                    <Grid item xs={2}>
                        <Tooltip title={t('download_all')}>
                            <ExcelFile
                                element={
                                    <Button 
                                        variant="contained" 
                                        color="primary"
                                        disabled={downloadExcel.length <= 0}
                                    >
                                        {t('download_excel')}
                                    </Button>
                                }
                            >
                                <ExcelSheet data={downloadExcel} name="Second Delivery">
                                    <ExcelColumn label="storage_info" value="storage_info"/>
                                    <ExcelColumn label="add_time" value="add_time"/>
                                    <ExcelColumn label="order_sn" value="order_sn"/>
                                    <ExcelColumn label="path_info" value="path_info"/>
                                    <ExcelColumn label="original_tno" value="original_tno"/>
                                    <ExcelColumn label="original_path_info" value="original_path_info"/>
                                    <ExcelColumn label="driver_id" value="driver_id"/>
                                    <ExcelColumn label="driver_name" value="driver_name"/>
                                    <ExcelColumn label="driver_notes" value="driver_notes"/>
                                    <ExcelColumn label="order_id" value="order_id"/>
                                    <ExcelColumn label="sub_referer" value="sub_referer"/>
                                </ExcelSheet>
                            </ExcelFile>
                        </Tooltip>
                    </Grid>
                }
            </Grid>
        </div>
    )
}

ActionSection.defaultProps = {
    onCreateBatch: ()=>{},
    onAutoDelivery: ()=>{},
    onTransferToDriver: ()=>{},
    downloadExcel: []
}

export default ActionSection